import { ReactiveVar } from '@apollo/client'
import IconCustomizeColumns from 'assets/icons/context-menu/customize-columns.svg'
import { showCustomizeColumnsVar } from '../../../../../cache/adv-filtering'

export const customizeColumns = (closeMenuVar: ReactiveVar<any>) => {
  return {
    icon: IconCustomizeColumns,
    content: 'Customize Columns',
    onClick: () => {
      showCustomizeColumnsVar(true)
      closeMenuVar(false)
    },
  }
}
